import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Bong = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M19.293 8.293l-2.069 2.069A7.017 7.017 0 0015 8.681V4h1V2H8v2h1v4.681A7.01 7.01 0 005 15c0 3.859 3.141 7 7 7s7-3.141 7-7a6.958 6.958 0 00-.652-2.934l2.359-2.359-1.414-1.414zm-8.959 1.998l.666-.235V4h2v6.056l.666.235A5.006 5.006 0 0116.886 14H7.114a5.006 5.006 0 013.22-3.709zM12 20a5.007 5.007 0 01-4.898-4h9.797A5.009 5.009 0 0112 20z",
    key: "k0"
  }));
});
Bong.displayName = 'Bong';
export var BongDimensions = {
  height: 24,
  width: 24
};